import { useEffect, useState } from "react";
import Button from "../../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../../../components/common/ui/Loader";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import { history } from "../../../../_helpers/history";
import { committeeActions } from "../../../../_store/committee.slice";
import { menuActions } from "../../../../_store/Admin/menu.slice";
import MenuTree from "../../../../components/common/menuTree/MenuTree";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import deleteIcon from "../../../../assets/svg/delete-icon.svg";
import menuIcon from "../../../../assets/svg/dashboard-menu.svg";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../../../components/common/ui/NotificationModal/Popup";

function MenuList() {
  const dispatch = useDispatch();
  const [menuData, setMenuData] = useState([]);
  const [filters, setFilters] = useState({
    committeeName: "",
    status: true,
  });
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`,
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);
  const { loading } = useSelector((x) => x.menu);
  const navigate = useNavigate();
  // 🔧 Define this before using
  const normalizeTree = (nodes) => {
    return [...nodes] // ✅ make a shallow copy
      .sort((a, b) => a.order - b.order)
      .map((node) => {
        const newNode = { ...node };
        if (newNode.child) {
          newNode.child = normalizeTree(newNode.child); // keep as 'child' if API sends that
        }
        return newNode;
      });
  };

  const loadMenu = () => {
    dispatch(menuActions.getMenuList())
      .then((result) => {
        if (result?.payload?.status === 1) {
          const rawMenuItems = result?.payload?.data?.menuItems;

          if (Array.isArray(rawMenuItems)) {
            const normalized = normalizeTree(rawMenuItems);
            setMenuData(normalized);
          } else {
            console.error("menuItems is missing or invalid:", rawMenuItems);
          }
        } else {
          showToastNotification(
            result?.error?.message || "Failed to load menu",
            "error",
          );
        }
      })
      .catch((err) => {
        showToastNotification("Failed to load menu", "error");
      });
  };

  useEffect(() => {
    loadMenu();
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      ),
    }).toString();

    setApiParams(`?${query}`);
  }, [filters]);

  const handleSearchChange = (e) => {
    const { name, value, type } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: type === "radio" ? (value === "true" ? true : false) : value,
    }));
  };

  const handleStatusChange = (e, row) => {
    dispatch(menuActions.enableDisableMenu(row?.id))
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          loadMenu();
          // dispatch(menuActions?.getMembers(apiParams));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };

  const handleRowPerPage = (page) => {
    const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
    setApiParams(updatedParams);
    dispatch(committeeActions?.getCommitteeList(updatedParams));
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(committeeActions?.getCommitteeList(updatedParams));
    setPageNo(page);
  };

  const handleEdit = (item) => {
    history?.navigate("/Admin/Menu/createOrEdit", {
      state: { menuID: item?.id },
    });
  };

  const handleMenu = (item) => {
    if (item?.routeMethod === "external") {
      showToastNotification(
        "For external menus, content updates are not applicable. You can directly paste the URL by clicking the pencil (Edit) icon.",
        "warning",
      );
      return;
    }
    history?.navigate("/Admin/Menu/subpage", {
      state: { item: item },
    });
  };

  const handleDelete = (item) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the menu?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        // setEventID(row?._id);

        dispatch(menuActions?.deleteMenu(item))
          .then((result) => {
            if (result?.error) {
              // Error case
              const errorMessage =
                result.error.message || "Something went wrong!";
              showToastNotification(errorMessage, "error");
            } else if (result?.payload?.message) {
              // Success case
              showToastNotification(result.payload.message, "success");
              loadMenu();
            }
          })
          .catch((err) => {
            showToastNotification("Failed to delete Menu", "error");
          });
      },
    });
  };

  const handleSearchSubmit = (e) => {
    // e?.preventDefault();
    // setPageNo(1);
    // setRowCountPerPage(10);
    // dispatch(committeeActions?.getCommitteeList(apiParams));
  };

  const handleFormReset = (e) => {
    // e?.preventDefault();
    // setFilters({
    //   committeeName: "",
    //   status: true,
    // });
    // const params = `?page=${1}&limit=${10}&status=${true}`;
    // setApiParams(params);
    // setPageNo(1);
    // setRowCountPerPage(10);
    // dispatch(committeeActions?.getCommitteeList(params));
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h1 className="header-color">Menu</h1>
        <Button
          status="secondary"
          label="Create Menu"
          onClick={() => {
            history?.navigate("/Admin/Menu/CreateOrEdit", {
              state: { menuID: 0 },
            });
          }}
        />
      </div>
      {/* <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          Search Menu
        </h1>
        <form
          className="p-3 row"
          onSubmit={(e) => {
            handleSearchSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
        >
          <div className="col-md-3">
            <TextInput
              label="Name"
              placeholder="Menu name"
              name="committeeName"
              handleChange={handleSearchChange}
              value={filters?.committeeName}
            />
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button status="secondary" label="Search" type="submit" />
            <Button status="reset" label="Reset" type="reset" />
          </div>
        </form>
      </div> */}
      {console.log(menuData)}
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100 p-1">
        <h1 className="m-0 search-header-color p-3 ">Menu List</h1>

        {menuData?.length === 0 ? (
          <div className="d-flex justify-content-center align-items-center h-100 p-4">
            <h4>No Menu Found</h4>
          </div>
        ) : (
          <MenuTree
            data={menuData}
            actions={[
              {
                title: "Dynamic Menu",
                icon: menuIcon,
                // onClick: navigate("Menu/subpage"),
                onClick: (item) => handleMenu(item),
              },
              {
                title: "Edit",
                icon: editIcon,
                onClick: (item) => handleEdit(item),
              },
              {
                title: "Delete",
                icon: deleteIcon,
                onClick: (item) => handleDelete(item.id),
              },
              {
                // ✅ Use render for a custom component
                render: (item) => (
                  <>
                    <ToggleSwitch
                      name={`Status${item.id}`}
                      id={`Status${item.id}`}
                      checked={item.status === true}
                      value={item.status ? 1 : 0}
                      handleClick={(e) => handleStatusChange(e, item)}
                    />
                  </>
                ),
              },
            ]}
          />
        )}
        {/* <MenuTree
          data={menuData}
          actions={[
            {
              title: "dynamicMenu",
              icon: menuIcon,
              // onClick: navigate("Menu/subpage"),
              onClick: (item) => handleMenu(item),
            },
            {
              title: "Edit",
              icon: editIcon,
              onClick: (item) => handleEdit(item),
            },
            {
              title: "Delete",
              icon: deleteIcon,
              onClick: (item) => handleDelete(item.id),
            },
            {
              // ✅ Use render for a custom component
              render: (item) => (
                <ToggleSwitch
                  name={`Status${item.id}`}
                  id={`Status${item.id}`}
                  checked={item.status === true}
                  value={item.status ? 1 : 0}
                  handleClick={(e) => handleStatusChange(e, item)}
                />
              ),
            },
          ]}
        /> */}
      </div>
    </>
  );
}

export default MenuList;
